import { createRoot } from 'react-dom/client';
import { Helmet } from 'react-helmet';
import App from './App';
import './theme/baseCSS.scss';

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

const DEFAULT_META_DESCRIPTION = '';
const DEFAULT_META_KEYWORDS = '';

root.render(
  <>
    <Helmet>
      <title>Urbanease, mot de passe oublié</title>
      <meta name="description" content={DEFAULT_META_DESCRIPTION} />
      <meta name="keywords" content={DEFAULT_META_KEYWORDS} />
    </Helmet>
    <App />
  </>
);
